import { render, staticRenderFns } from "./CompWrapper.vue?vue&type=template&id=75b671cb&lang=html&"
import script from "./CompWrapper.vue?vue&type=script&lang=js&"
export * from "./CompWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CompWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b671cb')) {
      api.createRecord('75b671cb', component.options)
    } else {
      api.reload('75b671cb', component.options)
    }
    module.hot.accept("./CompWrapper.vue?vue&type=template&id=75b671cb&lang=html&", function () {
      api.rerender('75b671cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/CompWrapper.vue"
export default component.exports